export default "__VITE_ASSET__Bq$$GUGt__"